import React from "react";
import { toast } from "react-toastify";
import { SimpleToast } from "./simpleToast";

export function createToast(title: string, message: string, type?: "error" | "success"): void {
	toast((props) => <SimpleToast title={title} message={message} type={type} {...props} />);
}
